import { ApButtonSecondary } from '@alixpartners/ui-components';
import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  LinksToSpendActions,
  LinksToSpendContainer,
  LinksToSpendDescription,
  LinksToSpendWrapper,
} from './Data.styles';

export const LinksToSpendFileUploads = () => {
  const history = useHistory();
  return (
    <LinksToSpendWrapper>
      <LinksToSpendContainer>
        <LinksToSpendDescription>
          Now upload a spend file for classification
        </LinksToSpendDescription>
        <LinksToSpendActions>
          <ApButtonSecondary
            iconName="cloud_upload"
            onClick={() => {
              history.push('/settings/data/third-party-spend');
            }}
          >
            Third party spend
          </ApButtonSecondary>
          <ApButtonSecondary
            iconName="cloud_upload"
            onClick={() => {
              history.push('/settings/data/personnel-spend');
            }}
          >
            Personnel spend
          </ApButtonSecondary>
        </LinksToSpendActions>
      </LinksToSpendContainer>
    </LinksToSpendWrapper>
  );
};
